import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    chipInput: {
        position: 'relative',
        minHeight: 32,
        '&:before': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
            backgroundColor: 'transparent',
        },
        '&:hover:not($disabled):before': {
            height: '1px',
        },
    },
    disabled: {},
    chip: {
        maxWidth: '85%',
    },
});
